import { Link } from 'react-router-dom'
import { List, SignOut } from '@phosphor-icons/react'
import { useAuthStore } from '@/stores/authStore'
import { useUiStore } from '@/stores/uiStore'
import { authService } from '@/services/api'
import { useQueryClient } from '@tanstack/react-query'

export function Header() {
	const toggleSidebar = useUiStore((s) => s.toggleSidebar)
	const clearAuth = useAuthStore((s) => s.clearAuth)
	const queryClient = useQueryClient()

	const handleLogout = async () => {
		await authService.logout()
		clearAuth()
		queryClient.clear()
	}

	return (
		<header className="border-b border-stone-200 bg-surface-elevated">
			<div className="flex h-16 items-center justify-between px-3 md:px-6">
				<div className="flex items-center gap-3">
					<button
						onClick={toggleSidebar}
						className="rounded-md p-2 text-stone-500 hover:bg-stone-100 hover:text-stone-700"
					>
						<List size={20} />
					</button>
					<Link to="/recipes" className="text-lg font-semibold text-stone-900 no-underline">
						Recipe Book
					</Link>
				</div>

				<button
					onClick={handleLogout}
					className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-stone-500 hover:bg-stone-100 hover:text-stone-700"
				>
					<SignOut size={18} />
					<span className="hidden sm:inline">Выйти</span>
				</button>
			</div>
		</header>
	)
}
